import s from './ReportFilters.module.css'
import { ReportAssessments, ReportFilterType } from 'widgets/report/types'
import { AssessmentPanelFilter } from 'features/assessment/filter'
import { getAssessmentReportFilterAttributes } from 'widgets/assessment/panel/config'
import { useTranslation } from 'react-i18next'

interface ReportFiltersProps {
  filter: ReportFilterType
  setFilter: (value: ReportFilterType) => void
  assessments: ReportAssessments
}

export const ReportFilters = ({
  filter,
  setFilter,
  assessments,
}: ReportFiltersProps) => {
  const { t } = useTranslation()
  const options = getAssessmentReportFilterAttributes(assessments, t)

  return (
    <AssessmentPanelFilter
      selectedFilters={[filter]}
      selectFilters={(value) => setFilter((value as any)[0])}
      filterAttributes={options}
      className={s.filter}
    />
  )
}
